import styled, { css } from 'styled-components'

export const Divider = styled.div<{ dashed?: boolean }>`
  border-bottom: 1px solid rgb(239, 240, 250);
  width: 100%;
  margin: 15px 0;

  ${({ dashed }) =>
    dashed &&
    css`
      border-bottom-style: dashed;
    `}
`

export const Stack = styled.div<{
  gap?: number
}>`
  display: flex;
  flex-direction: column;
  gap: ${(props) => `${props.gap || 4}px`};
  width: 100%;
`

export const Spacer = styled.div<{
  h?: number
  w?: number
}>`
  ${(props) =>
    props.w &&
    css`
      height: 1px;
      width: ${props.w}px;
    `}
  ${(props) =>
    props.h &&
    css`
      height: ${props.h}px;
      width: 1px;
    `}
`

export const FootNote = styled.div`
  font-size: 12px;
  text-align: center;
  color: #847cae;
  font-weight: 300;
  margin-top: 15px;
  width: 100%;
`
